import request from '@utils/request'

export function fetchTicketTypes() {
  return request({
    url: `/admin/cs/ticket/type`,
  })
}

export function fetchTicketType(seq) {
  return request({
    url: `/admin/cs/ticket/type/${seq || 0}`,
    method: 'get',
  })
}

export function createTicketType(data) {
  return request.post('/admin/cs/ticket/type', data)
}

export function updateTicketType(data) {
  return request.put(`/admin/cs/ticket/type/${data.seq}`, data)
}

export function deleteTicketType(seq) {
  return request.delete(`/admin/cs/ticket/type/${seq}`)
}

export function fetchTicketList(params) {
  return request({
    url: '/admin/cs/ticket',
    method: 'get',
    params,
  })
}

export function fetchTicket(ticket_seq) {
  return request.get(`/admin/cs/ticket/${ticket_seq || 0}`)
}

export function updateTicket(data) {
  return request.put(`/admin/cs/ticket/${data.seq}`, data)
}

export function closeTicket(ticket_seq) {
  return request({
    url: `/admin/cs/ticket/${ticket_seq}`,
    method: 'patch',
    data: {
      type: 'SET_CLOSED',
    },
  })
}

export function replyTicket(ticket_seq) {
  return request({
    url: `/admin/cs/ticket/${ticket_seq}`,
    method: 'patch',
    data: {
      type: 'REPLY',
    },
  })
}

export function createFaq(data) {
  return request.post('/admin/cs/faq', data)
}

export function updateFaq(data) {
  return request.put(`/admin/cs/faq/${data.seq}`, data)
}

export function fetchFaqList(params) {
  return request({
    url: '/admin/cs/faq',
    method: 'get',
    params,
  })
}

export function fetchFaq(faq_seq) {
  return request.get(`/admin/cs/faq/${faq_seq || 0}`)
}

export function deleteFaq(seq) {
  return request.delete(`/admin/cs/faq/${seq}`)
}

export function fetchFaqTypes() {
  return request({
    url: `/admin/cs/faq/type`,
    method: 'get',
  })
}

export function fetchFaqType(seq) {
  return request({
    url: `/admin/cs/faq/type/${seq || 0}`,
    method: 'get',
  })
}

export function createFaqType(data) {
  return request.post('/admin/cs/faq/type', data)
}

export function updateFaqType(data) {
  return request.put(`/admin/cs/faq/type/${data.seq}`, data)
}

export function deleteFaqType(seq) {
  return request.delete(`/admin/cs/faq/type/${seq}`)
}
